import type { PosConnection } from "@tycho/web-bindings/types";
import { CompletedActionCard } from "@/web/routes/_protected/smb/-dashboard/-CompletedActionCard";
import type { SmbActionDefinition } from "@/web/routes/_protected/smb/-dashboard/-types";

type Props = {
  connection: PosConnection;
};

function platformLabel(platform: string): string {
  if (!platform) return "Point of sale";
  return platform.charAt(0).toUpperCase() + platform.slice(1).toLowerCase();
}

export function createConnectPosCompleted(props: Props & { id?: string }): SmbActionDefinition {
  const { connection, id = `connect-pos:done:${connection.id}` } = props;
  const label = platformLabel(connection.platform);
  return {
    id,
    category: "budget",
    canSkip: false,
    render: () => (
      <CompletedActionCard
        category="budget"
        badge="Budget"
        title={`${label} connected`}
        details={{
          title: "POS connected",
          children: (
            <div className="flex flex-col gap-2">
              <p className="font-medium">{label}</p>
              <p className="opacity-70">
                We're pulling in transaction volume so we can verify your sales without
                spreadsheets.
              </p>
            </div>
          ),
        }}
      />
    ),
  };
}
